import { TypeExpertise } from "../enums/TypeExpertise"

export class SiteTypeExpertise
{
    inspection_type!: TypeExpertise
    site_id!: number
    IDCompany!: number

    constructor(data?: Partial<SiteTypeExpertise>) {
        Object.assign(this, data)
    }
}
